'use client';

import { useState } from 'react';

// Google Form Configuration - Updated to match your responses form
const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/d/e/1FAIpQLSfw2VDNgtGPUdPriilDtJgs99DNUH22ULI9lmkzEdPw86emBg/formResponse';
const GOOGLE_FORM_FIELDS = {
  name: 'entry.2005620554',
  email: 'entry.1045781291',
  phone: 'entry.1166974658',
  subject: 'entry.839337160',
  message: 'entry.1694846781'
};         

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      // Create a temporary form element for submission
      const tempForm = document.createElement('form');
      tempForm.action = GOOGLE_FORM_ACTION;
      tempForm.method = 'POST';
      tempForm.target = 'hidden_iframe';
      tempForm.style.display = 'none';
      
      // Create form fields
      const fields = [
        { name: GOOGLE_FORM_FIELDS.name, value: formData.name },
        { name: GOOGLE_FORM_FIELDS.email, value: formData.email },
        { name: GOOGLE_FORM_FIELDS.phone, value: formData.phone },
        { name: GOOGLE_FORM_FIELDS.subject, value: formData.subject },
        { name: GOOGLE_FORM_FIELDS.message, value: formData.message },
        { name: 'fvv', value: '1' },
        { name: 'partialResponse', value: '[null,null,"8083926918408286226"]' },
        { name: 'pageHistory', value: '0' },
        { name: 'fbzx', value: '8083926918408286226' }
      ];
      
      // Add input fields to form
      fields.forEach(field => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = field.name;
        input.value = field.value;
        tempForm.appendChild(input);
      });
      
      // Create hidden iframe for form submission
      let iframe = document.getElementById('hidden_iframe') as HTMLIFrameElement;
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'hidden_iframe';
        iframe.name = 'hidden_iframe';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }
      
      // Add form to document and submit
      document.body.appendChild(tempForm);
      tempForm.submit();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(tempForm);
        setIsSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
        setIsSubmitting(false);
      }, 1000);
      
    } catch (err) {
      console.error('Form submission error:', err);
      setError('Failed to send message. Please check your connection and try again.');
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 lg:p-8 text-center">
        <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4 sm:mb-6">
          <i className="ri-check-line text-green-600 text-xl sm:text-2xl"></i>
        </div>
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">Message Sent Successfully!</h3>
        <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
          Thank you for reaching out to us. Our team will get back to you within 24 hours.
        </p>
        <button
          onClick={() => setIsSubmitted(false)}
          className="bg-green-600 text-white px-6 py-3 rounded-full hover:bg-green-700 transition-colors whitespace-nowrap text-sm sm:text-base"
        >
          Send Another Message
        </button>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Send us a Message</h2>
      
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-3 sm:px-4 py-3 rounded-lg mb-4 sm:mb-6">
          <p className="text-xs sm:text-sm font-semibold">❌ {error}</p>
          <div className="mt-2 sm:mt-3 text-xs text-red-600">
            <p><strong>Possible solutions:</strong></p>
            <ul className="list-disc list-inside mt-1 space-y-1">
              <li>Make sure your Google Form accepts responses from anyone</li>
              <li>Verify the entry IDs match your form fields</li>
              <li>Check if your form is published and accessible</li>
            </ul>
          </div>
        </div>
      )}
      
      <form id="contact-form" onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
              Full Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors"
              placeholder="Enter your full name"
            />
          </div>
          
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Email Address *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors"
              placeholder="Enter your email"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
              Phone Number
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors"
              placeholder="Enter your phone number"
            />
          </div>
          
          <div>
            <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
              Subject *
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors"
              placeholder="Enter subject"
            />
          </div>
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
            Message *
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows={4}
            maxLength={500}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors resize-none text-sm sm:text-base"
            placeholder="Tell us how we can help you..."
          ></textarea>
          <div className="text-right text-sm text-gray-500 mt-1">
            {formData.message.length}/500 characters
          </div>
        </div>

        <button
          type="submit"
          disabled={isSubmitting || formData.message.length > 500}
          className="w-full bg-green-600 text-white py-3 px-6 rounded-full font-semibold hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap text-sm sm:text-base"
        >
          {isSubmitting ? (
            <div className="flex items-center justify-center space-x-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Sending...</span>
            </div>
          ) : (
            'Send Message'
          )}
        </button>
      </form>
    </div>
  );
}